import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';
import LocaleService from 'modules/Localization';
// UI
import {
  View,
  Text,
  CloseAltIcon,
  RefreshAltIcon,
  SettingsAltIcon,
  ExpandAltIcon,
  CollapseAltIcon,
} from '@upstox/upstox-ui';
// components
import SpotPriceCell from './components/SpotPriceCell/SpotPriceCell';
import ExpiryDropdown from '../ExpiryDropdown';
import ExpiryDaysCell from './components/ExpiryDaysCell/ExpiryDaysCell';
import MarketLotCell from './components/MarketLotCell/MarketLotCell';
import MaxPainCell from './components/MaxPainCell/MaxPainCell';
import PcrCell from './components/PcrCell/PcrCell';
// styles
import * as css from './styles';
import FuturePriceCell from './components/FuturePriceCell/FuturePriceCell';

type OCHeaderProps = {
  closeModal: () => void;
  refreshOptionChainTable: () => void;
};
const OptionChainHeader: React.FC<OCHeaderProps> = props => {
  const {
    closeModal,
    refreshOptionChainTable,
  } = props;
  const {
    loading,
    scripData,
    spotScripData,
    futureScrip,
    setOpenSettings,
    isOptionChainAvailable,
    setIsMinimised,
    isMinimised,
  } = useStore('OptionChainStore');

  return (
    <View css={css.headerContainer}>
      <View css={css.symbolInfo}>
        <View css={css.symbolName}>
          {spotScripData?.displayName || scripData?.name}
        </View>
        <View css={css.settingsContainer} cssProps={{ isOptionChainAvailable }}>
          {!!isOptionChainAvailable && (
            <Fragment>
              {!loading && (
                <View alignItems="center" css={css.expiryContainer}>
                  <Text css={css.expiryLabel} family="tvFont">
                    {LocaleService.translate('EXPIRY')}
                  </Text>
                  <ExpiryDropdown />
                </View>
              )}
              <View
                css={css.iconContainer}
                onClick={isMinimised ? undefined : refreshOptionChainTable}
              >
                <RefreshAltIcon
                  css={css.icon}
                  cssProps={{
                    iconColor: isMinimised ? 'disabled.2' : 'icon1',
                    isMinimised,
                  }}
                />
              </View>
              <View
                css={css.iconContainer}
                onClick={() =>
                  (isMinimised ? undefined : setOpenSettings(true))}
              >
                <SettingsAltIcon
                  css={css.icon}
                  cssProps={{
                    iconColor: isMinimised ? 'disabled.2' : 'icon1',
                    isMinimised,
                  }}
                />
              </View>
            </Fragment>
          )}

          <View
            css={css.iconContainer}
            cssProps={{ shifToRight: !isOptionChainAvailable }}
          >
            {isMinimised ? (
              <ExpandAltIcon
                size="xxlarge"
                css={css.icon}
                cssProps={{ iconColor: 'icon1' }}
                onClick={() => setIsMinimised(!isMinimised)}
              />
            ) : (
              <CollapseAltIcon
                size="xxlarge"
                css={css.icon}
                cssProps={{ iconColor: 'icon1' }}
                onClick={() => setIsMinimised(!isMinimised)}
              />
            )}
          </View>

          <View
            css={css.iconContainer}
            cssProps={{ shifToRight: !isOptionChainAvailable }}
          >
            <CloseAltIcon
              size="xxlarge"
              css={css.icon}
              cssProps={{ iconColor: 'icon1' }}
              onClick={closeModal}
            />
          </View>
        </View>
      </View>
      {/* Option Chain Data Cells */}
      <View
        flexDirection="row"
        justifyContent="space-between"
        css={css.headerDataContainer}
      >
        <View css={css.dataContainer}>
          {futureScrip && <FuturePriceCell />}
          <SpotPriceCell />
        </View>

        {!!isOptionChainAvailable && (
          <View flexDirection="row" css={css.dataContainer}>
            <PcrCell />
            <MaxPainCell />
            <MarketLotCell />
            <ExpiryDaysCell />
          </View>
        )}
      </View>
    </View>
  );
};

export default observer(OptionChainHeader);
